// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"b64fd853","277":"6205a4b8","458":"81ff94aa","465":"b310cdb9","533":"ca1b535b","732":"81ff94aa","758":"566caf5a","976":"81ff94aa"}[chunkId] + ".chunk.css";
};